var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bitmap Copy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Travelers---United-States-Search",
    transform: "translate(-83.000000, -528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-2",
    transform: "translate(39.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap-Copy",
    x: 44,
    y: 127,
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAABGdBTUEAALGOfPtRkwAABC1JREFUaAXVWE1WGkEQrmp4ugw5QcgJxBOEnEBMMFvJTthIThByAnGD7oRtIA9zAvUE4gmCNyC7mCfTqZpmZnqGHsDphmi/x1Bd/VP1Tf1MdSNkbY3+LQCWQMo2nB18ybqNi3Ui8yYS0V+L2ITG4CLzPg4WWoCQTU1+7X8CyQ7i/OCaXOnmOQDJDoK1x5g1mEMW+VFjYpPNDkTn0wgk9OIKywuoDypx3np7KjhtZBwNiyCmvxJbTMhKNfByk5B/9kF3vZDtgrAHwVrUB11AOFyoEFvsrFpbOCfjoJ07BUJlrhWQqf8IkVVSJ2UbcAPifH88HxuBQnJEbvUWOlU9JQeDTv7dgGBVUq1BX3V8XGuguwPB1gD50/hqEU/WmbHcgWDtPWgbQTAT4QIa30up4xYDbrKTrkB9MCKFd3RWRFN8gLgM+553A/zlt2x5y/XzyxHJGvTBMzaKD5D0mzWBE6JeB92s/8IvExqDY2gOC1k3ia3rfOxSTfU7xjN11JyeaeipPAHSa9OiNvx9vHIGBLG7VBEUTVdplwO7pQSSqZ0B8bpqz0VPeeIq0FVgNwZjEvdGiaTg28q/h/Y++2v2Vu9T/YSvFm4gYQzbuV1bWbMUi61ImCOLIFxHe6ZQCEV4mA5TRldmKxAcjAD30SonQEbRfgsohDI0+q0FM5YOKXfiaY0BB/hxfIXmWpy9HuROOC6mBZCiFPYDQnoF/wIB6C3zm161yYTlEK/Dpehx/TWBbbwzuV4E4qhfBoFX4cLnSnAcAbCVL6m077Gas5hg8oU0ti5ChX5dqsf8lx6BEHLyQmDoavpf+6js8LDwYuzCtyyc/bbzbUYUgRBY0SH6tIQ7yuNl+PNYCseQwKJW//CAxCI96Kc1xCL1Zt8ejZ9O3lO5Mo4Nq9PgyOdJpEsJ8hZDwRiBkLBH6KLGtQ0f9tvVCTGvowGfukz057t+2sSv8wMGjuX5W8UEX7Ho6VABKANfyWRtvnVWWMzWtrxACAI7+j64AKB0f7cUAstid7VseXVjJ9VGrgCoE1xxqW5Icm1rNBJCpbhUfusKgK+5qC0FAPjZyl01AYKCt0eZ5Rulq6KrTen6Zk+TYSalPCQvWC3wzTuEXD0fhUwrQiWJ4cp7dKrWOkQpdmWpSydGSSI5lV1W1T18+zGh70s3OSVL3/otxISaL5e1Kd6uM5fVdg1SrMayIHHaSl/tLpCTMtxZYrEVTl1dCiQBcN+dJdKswMXaGi+TGYQbSyy2Asuhxu7kH4NV1+HTjSXSrBBT1KvEug479imWrYDTQ4NOp/QR5QqYmhjDVm555asmP/lpD8JohfW5jgmhXUyYY2GtmcgEws4SSSuow03TJGidvOyW8MttcRsqpw43pbC/QSJ7dpLiJNQzOIuHjM0S2UGA3PVV5Y8Zn84cHG42C/2ZSfsHslZVyjLcAKYAAAAASUVORK5CYII="
  }))))));
};

export default __webpack_public_path__ + "static/media/airplane.a0626afd.svg";
export { SvgComponent as ReactComponent };